import { quantityOfDaysInWeek } from './constants'

const startOfTheDay = (date: Date): Date => {
  const newDate = new Date(date)
  newDate.setHours(0, 0, 0, 0)
  return newDate
}

const endOfTheDay = (date: Date): Date => {
  const newDate = new Date(date)
  newDate.setHours(23, 59, 59, 999)
  return newDate
}

export const setHoursInRangeDates = (rangeStart: Date, rangeEnd: Date): Date[] => {
  const start = startOfTheDay(rangeStart)
  const end = endOfTheDay(rangeEnd)
  return [start, end]
}

export const getPreviousDateWithMonthPeriod = (date: Date, monthQuantity: number): Date => {
  if (monthQuantity <= 0) return date
  const selectedDate = new Date(date)
  const previousMonthOnYear: number = selectedDate.getMonth() - monthQuantity
  const previousDate = new Date(selectedDate.setMonth(previousMonthOnYear))

  return previousDate
}

export const getNextDateWithMonthPeriod = (date: Date, monthQuantity: number): Date => {
  if (monthQuantity <= 0) return date
  const selectedDate = new Date(date)
  const nextMonthOnYear: number = selectedDate.getMonth() + monthQuantity
  const nextDate = new Date(selectedDate.setMonth(nextMonthOnYear))

  return nextDate
}

export const getMonthName = (date: Date): string => {
  const monthName = new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(date)
  const capitalizedMonthName = monthName.charAt(0).toUpperCase() + monthName.substring(1)
  return capitalizedMonthName
}

export const getCurrentYear = (date: Date): string => {
  const fullYear = date.getFullYear()
  return fullYear.toString()
}

export const getAllDaysInMonth = (date: Date): Date[] => {
  const month = date.getMonth()
  const year = date.getFullYear()
  const iteratedDate = new Date(year, month, 1)
  const allDaysInMonth: Date[] = []

  while (iteratedDate.getMonth() === month) {
    allDaysInMonth.push(new Date(iteratedDate))
    iteratedDate.setDate(iteratedDate.getDate() + 1)
  }

  return allDaysInMonth
}

export const getPeriodDaysOfPreviousMonth = (date: Date, daysQuantity: number): Date[] => {
  const month = date.getMonth()
  const year = date.getFullYear()
  const daysOfPeriod: Date[] = []
  let loopCounter = 1

  while (daysQuantity >= loopCounter) {
    daysOfPeriod.push(new Date(year, month, loopCounter - daysQuantity))
    loopCounter++
  }

  return daysOfPeriod
}

export const getPeriodDaysOfNextMonth = (date: Date, daysQuantity: number): Date[] => {
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const daysOfPeriod: Date[] = []
  let loopCounter = 1

  while (daysQuantity >= loopCounter) {
    daysOfPeriod.push(new Date(year, month, loopCounter))
    loopCounter++
  }

  return daysOfPeriod
}

export const isSunday = (day: number): boolean => day === 0

export const createDaysAvailableInPeriod = (date: Date): Date[] => {
  const allDaysInMonth = getAllDaysInMonth(date)

  const dayNameOfFirstDayInMonth: number = allDaysInMonth[0].getDay()
  const quantityOfDaysToGetInPreviousMonth = isSunday(dayNameOfFirstDayInMonth) ? 6 : dayNameOfFirstDayInMonth - 1

  const numberOnWeekOfLastDayInMonth = allDaysInMonth[allDaysInMonth.length - 1].getDay()
  const quantityOfDaysToGetInNextMonth = isSunday(numberOnWeekOfLastDayInMonth)
    ? 0
    : quantityOfDaysInWeek - numberOnWeekOfLastDayInMonth

  if (quantityOfDaysToGetInNextMonth !== 0) {
    const nextMonthDays = getPeriodDaysOfNextMonth(date, quantityOfDaysToGetInNextMonth)
    allDaysInMonth.push(...nextMonthDays)
  }
  if (quantityOfDaysToGetInPreviousMonth !== 0) {
    const previousMonthDays = getPeriodDaysOfPreviousMonth(date, quantityOfDaysToGetInPreviousMonth)
    allDaysInMonth.unshift(...previousMonthDays)
  }

  return allDaysInMonth
}

export const verifyIfDayIsBetweenDates = (date: Date, startDate: Date, endDate: Date): boolean => {
  if (!startDate || !endDate) return false
  return date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()
}

export const verifyIfDayExists = (day: Date, arrayOfDates: Date[]): boolean => {
  return !!arrayOfDates.find(date => startOfTheDay(date).getTime() === startOfTheDay(day).getTime())
}

export const verifyIfMonthIsDifferent = (date1: Date, date2: Date): boolean => {
  return date1.getMonth() !== date2.getMonth()
}

export const returnNewSelectedDates = (day: Date, selectedPeriod: Date[]): Date[] => {
  const timestampDay = day.getTime()

  if (verifyIfDayExists(day, selectedPeriod)) {
    const removeDuplicates = selectedPeriod.filter(existentDay => existentDay.getTime() !== timestampDay)
    return removeDuplicates
  }

  const newSelectedPeriod = [...selectedPeriod, day]
  const orderedPeriod = newSelectedPeriod.sort((a, b) => a.getTime() - b.getTime())

  return orderedPeriod
}
